module.exports = __webpack_public_path__ + "static/img/135.457cef9b.png";